import React from 'react';
import Card from './Card';
import { connect } from 'react-redux';
import { tooltipHide, tooltipShow } from '../../../../actions/tooltipActions';
import PropTypes from 'prop-types';
import EditPaymentDetails from './_EditPaymentDetails';
import ReplaceCardTooltip from './_ReplaceCardTooltip';
import Stripe from '../../../shared/stripe/Stripe';
import Immutable from 'immutable';
import CheckIfAnyData from '../../../shared/CheckIfAnyData';
import { REPLACE_CARD_TOOLTIP_ID } from '../../../../constants/modals';

class PaymentMethods extends React.Component {
    _handleShowTooltip = (id) => () => {
      const { showTooltip } = this.props;

      showTooltip(id);
    };

    _handleHideTooltip = (id) => () => {
      const { hideTooltip } = this.props;

      hideTooltip(id);
    };

    render() {
      const { cardDetails } = this.props;
      const cardDetailsSize = cardDetails ? cardDetails.size : 0;

      return (
        <CheckIfAnyData dataSize={ cardDetailsSize }>
          <div className={ 'payment-methods' }>
            <div>
              <Card cardDetails={ cardDetails } />
              <div className={ 'payment-methods__options' }>
                <div className={ 'payment-methods__card-item' } onClick={ this._handleShowTooltip(REPLACE_CARD_TOOLTIP_ID) }>Replace card</div>
              </div>
            </div>
            <EditPaymentDetails />
            <Stripe>
              <ReplaceCardTooltip id={ REPLACE_CARD_TOOLTIP_ID }
                onHandleHideTooltip={ this._handleHideTooltip(REPLACE_CARD_TOOLTIP_ID) } />
            </Stripe>
          </div>
        </CheckIfAnyData>
      );
    }
}

PaymentMethods.propTypes = {
  cardDetails: PropTypes.instanceOf(Immutable.Map),
  hideTooltip: PropTypes.func.isRequired,
  showTooltip: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
  console.log(state.getIn(['paymentDetails'], Immutable.Map()))
  return {
    cardDetails:  state.getIn(['paymentDetails', 'data', 'card'], Immutable.Map()),
    loading:  state.getIn(['paymentDetails', 'loading'])
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    hideTooltip: (id) => {
      dispatch(tooltipHide({ id: id }));
    },
    showTooltip: (id) => {
      dispatch(tooltipShow({ id: id }));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentMethods);



// WEBPACK FOOTER //
// ./app/components/reps/settings/paymentMethods/PaymentMethods.jsx